import { BreakingLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import {
  backgroundImageLinearGradient,
  mq,
  offset,
  paddingV,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import { constrainWide } from '@sleepstation/style-mixins'
import { reversedTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'
import siteHeaderStartscapes from '../../../../svg/starscapes/siteHeaderStartscapes'
import LogoLink from '../shared/LogoLink'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const toBackgroundImage = (size) => (props) => {
  const image = props.images[size]
  return css`
    background-image: url(${image.url});
    background-position: ${image.position};
  `
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Image = styled.div`
  position: absolute;
  ${offset(0)}
  background-repeat: no-repeat;

  ${mq(`xSmallOnly`)} {
    ${toBackgroundImage(`xSmall`)}
  }

  ${mq(`smallOnly`)} {
    ${toBackgroundImage(`small`)}
  }

  ${mq(`mediumUp`)} {
    ${toBackgroundImage(`medium`)}
  }
`

const Layout = styled.div`
  position: relative;

  /* Ensure header is in front of body */
  z-index: 2 !important;
  ${backgroundImageLinearGradient()}
  ${stylesIfPropTrue(
    `hideBackground`,
    css`
      background-image: none;
    `
  )}

  > * {
    ${paddingV([0.5, 0.75])}
    flex: 0 0 auto;
  }
`

const Inner = styled(BreakingLayout).attrs({
  spacing: LAYOUT_SPACING.BETWEEN,
  align: LAYOUT_ALIGN.CENTER,
})`
  ${constrainWide()}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SiteHeaderDefault = ({ hideBackground }) => (
  <ThemeProvider theme={reversedTheme}>
    <Layout as="header" hideBackground={hideBackground}>
      {!hideBackground && <Image images={siteHeaderStartscapes} />}
      <Inner>
        <LogoLink />
      </Inner>
    </Layout>
  </ThemeProvider>
)

SiteHeaderDefault.propTypes = {
  hideBackground: PropTypes.bool,
}

SiteHeaderDefault.defaultProps = {
  hideBackground: false,
}

export default SiteHeaderDefault
